import { ArticleJsonLD, BreadCrumbJsonLD } from './json-ld';
import { ArticleOpenGraph } from './og';
import { ArticleTDK } from '@article/head/tdk';
import { ArticlePreload } from '@article/head/preload';
import { FC, Suspense } from 'react';
import { ArticleCanonical } from '@article/head/canonical';
import { ArticleRobots } from '@article/head/rebots';
import { ArticleTwitter } from '@article/head/twitter';

export const ArticleHead: FC = () => {
  return (
    <>
      <ArticleTDK />
      <ArticleRobots />
      <ArticlePreload />
      <ArticleCanonical />
      <ArticleOpenGraph />
      <ArticleTwitter />
      <Suspense>
        <BreadCrumbJsonLD />
        <ArticleJsonLD />
      </Suspense>
    </>
  );
};
